export const PICTURES_SHOW = "pictures-show"
export const PICTURES_CAMERA = "pictures-camera"
export const PICTURES_TEXT = "pictures-text"

export const any = [PICTURES_SHOW, PICTURES_CAMERA, PICTURES_TEXT]



// WEBPACK FOOTER //
// ./src/features/damage-case/screens.js